<div [ngClass]="brandThemeClass">
  <ng-container *ngIf="!(loading$ | async); else loadingPlans">
    <ng-container *ngIf="cs.vm$ | async as vm" [cmsContent]="vm.cmsContent">
      <div class="above-fold">
        <div (click)="headerNavClick($event)">
          <dgx-components-header
            [navigation]="navigationLinks"
            [clientLogo]="clientLogo"
            [clientLogoNavigationLink]="navigationLink"
          >
          </dgx-components-header>
        </div>
        <dgx-components-loading-overlay
          *ngIf="loggingOut"
        ></dgx-components-loading-overlay>
        <div *ngIf="isScottishPower()" class="mobile-powered-container">
          <dgx-components-grid-container>
            <div class="mobile-powered-logo"></div>
          </dgx-components-grid-container>
        </div>
        <ng-container *ngIf="showBreadcrumbs; else homePageLayout">
          <dg-breadcrumb-search-bar></dg-breadcrumb-search-bar>
          <smart-fix-hub-page-wrapper>
            <router-outlet> </router-outlet
          ></smart-fix-hub-page-wrapper>
        </ng-container>

        <ng-template #homePageLayout>
          <main class="main" id="main">
            <router-outlet></router-outlet>
          </main>
        </ng-template>
      </div>

      <smart-fix-hub-footer></smart-fix-hub-footer>

      <dgx-components-modal-container />

      <dgx-notifications *ngIf="notificationsEnabled" />
    </ng-container>
  </ng-container>
  <ng-template #loadingPlans
    ><dgx-components-loading-overlay></dgx-components-loading-overlay>
  </ng-template>
</div>
